import React from "react";
import styles from "./diccionario.module.css";

export default function DictionaryHeader({
  letter,
  setLetter,
  query,
  setQuery,
  letters = ["A", "B", "C"],
}) {
  return (
    <header className={styles.header}>
      <div className={styles.headerTop}>
        <h1 className={styles.title}>Diccionario</h1>
        <div className={styles.searchWrap}>
          <input
            className={styles.search}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar término…"
            aria-label="Buscar término"
          />
        </div>
      </div>

      <nav className={styles.tabs} aria-label="Letras del diccionario">
        {letters.map((L) => (
          <button
            key={L}
            type="button"
            className={`${styles.tab} ${letter === L ? styles.active : ""}`}
            onClick={() => setLetter(L)}
          >
            {L}
          </button>
        ))}
      </nav>
    </header>
  );
}
